import { Suggestion } from './Suggestion.interface';

export class SuggestionModel implements Suggestion {
  title: string;
  url?: string;
  isCount?: boolean;

  constructor(data: any) {
    this.title = data.title || '';
    this.url = data.url || null;
    this.isCount = data.isCount || false;
  }
}
